// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const disasterRecoveryHelper = require('utilities/contactCenter/disasterRecoveryhelper');
const loginHelper = require('utilities/loginHelper');
const usd = require('utilities/usd');
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const {
    DR_RENEW_AGENT_TOKEN_INTERVAL_IN_MINUTES,
    DR_SESSION,
} = require('constants/contactCenter/session');

const agentTokenRenewalRequest = () => ({
    type: actionTypes.DISASTER_RECOVERY_RENEW_AGENT_TOKEN_REQUEST,
});

const agentTokenRenewalSuccess = () => ({
    type: actionTypes.DISASTER_RECOVERY_RENEW_AGENT_TOKEN_SUCCESS,
});

const agentTokenRenewalError = error => ({
    type: actionTypes.DISASTER_RECOVERY_RENEW_AGENT_TOKEN_FAILURE,
    payload: {
        error
    }
});

const renewAgentToken = (history) => (dispatch, getState) => {
    const immDisasterRecoveryAgentTokenRenewal = getState().disasterRecoveryAgentTokenRenewal;
    const isAlreadyFetching = immDisasterRecoveryAgentTokenRenewal.get('isFetching');
    const { bankToken, agentId, inOffice } = disasterRecoveryHelper.retrieveAgentInfo();

    if (!isAlreadyFetching && bankToken) {
        const requestData = {
            query: {
                bankToken,
            }
        };

        window.console.log('Agent token renewal for agent id: ', agentId);
        dispatch(agentTokenRenewalRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('agentTokenRenew'), requestData)
            .then(response => {
                const newAgentToken = response.tokenCredential;
                disasterRecoveryHelper.saveAgentLoginInfo({
                    bankToken: newAgentToken,
                    agentId,
                    inOffice,
                });
                usd.refreshAgentToken(newAgentToken);

                const drSession = sessionStorage.getItem(DR_SESSION);
                if (drSession) {
                    loginHelper.executeSharedLogin({
                        onLoginSuccess: () => {
                            window.console.log('New representation token generated after agent token renewal.');
                        },
                    }, history);
                }

                dispatch(agentTokenRenewalSuccess());
            })
            .catch(response => dispatch(agentTokenRenewalError(response)));
    } else {
        return Promise.resolve();
    }
}

const timerStart = (timer) => ({
    type: actionTypes.DISASTER_RECOVERY_RENEW_AGENT_TOKEN_TIMER_START,
    payload: {
        timer
    }
});

const timerStop = () => ({
    type: actionTypes.DISASTER_RECOVERY_RENEW_AGENT_TOKEN_TIMER_STOP
});

const startAgentTokenRenewalTimer = (history) => (dispatch, getState) => {
    const interval = DR_RENEW_AGENT_TOKEN_INTERVAL_IN_MINUTES * 60 * 1000;
    const immDisasterRecoveryAgentTokenRenewal = getState().disasterRecoveryAgentTokenRenewal;
    let timer = immDisasterRecoveryAgentTokenRenewal.get('timer');

    if (timer) {
        clearInterval(timer);
    }

    timer = setInterval(() => dispatch(renewAgentToken(history)), interval);
    dispatch(timerStart(timer));
    window.console.log('Agent token renewal timer started to run every %s minutes', DR_RENEW_AGENT_TOKEN_INTERVAL_IN_MINUTES);
};

const stopAgentTokenRenewalTimer = () => (dispatch, getState) => {
    const immDisasterRecoveryAgentTokenRenewal = getState().disasterRecoveryAgentTokenRenewal;
    const timer = immDisasterRecoveryAgentTokenRenewal.get('timer');

    if (timer) {
        clearInterval(timer);
    }

    dispatch(timerStop());
    window.console.log('Agent token renewal timer stopped');
}

module.exports = {
    startAgentTokenRenewalTimer,
    stopAgentTokenRenewalTimer,
};
